import React from 'react';
import tw, { styled } from 'twin.macro';
import addToMailchimp from "gatsby-plugin-mailchimp"

const Div = styled.div`
  ${tw`
    font-sans flex items-center py-2
  `}
`;

const Button = tw.button`
flex-shrink-0 px-8 rounded-r-sm text-white font-bold p-3 uppercase bg-darkgrey border-t border-b border-r focus:outline-none border-darkgrey
`;

class SubscribtionForm extends React.Component {

  constructor() {
    super()
    this.state = { email: "", result: {"result": null} }
  }

  _handleSubmit = async e => {
    e.preventDefault()
    const result = await addToMailchimp(this.state.email)
    this.setState({result: result})
    if (result.result === "error"){
      if (result.msg.includes("already subscribed")){
        alert("You are already subscribed to the list.")
      }
      else {
        alert(result.msg)
      }
    }
  }

  handleChange = event => {
    this.setState({ email: event.target.value })
    console.log(this.state.email)
  }

  render() {
    return (
      this.state.result.result === "success" ? (
        <Div>                
          Thank you for subscribing!
        </Div>
      ) : (
        <form className="w-full max-w-sm" onSubmit={this._handleSubmit}>
          <Div>
            <input 
            className="w-full rounded-l-sm rounded-r-none p-3 border-t mr-0 border-b border-l text-darkgrey border-mediumgrey bg-white focus:outline-none appearance-none"
            placeholder="email" 
            type="text" 
            aria-label="email" 
            onChange={this.handleChange}/>
            <Button type="submit">Subscribe</Button>
          </Div>
        </form>
      )
    )
  }
}

export default SubscribtionForm;
